import { EditOutlined } from '@ant-design/icons';
import { AppTable } from 'shared/UI/UIKit/Table';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppInput } from 'shared/UI/UIKit/Input';
import { AppText } from 'shared/UI/UIKit/Text';
import { useEducationPlan } from '../model';
import { AddClassesModal } from './components';
import styles from './styles.module.scss';

export const EducationPlan = () => {
  const {
    state: {
      loading,
      columns,
      dataSource,
      educationClasses,
      selectedClassKeys,
      classesModalVisible,
      editMode,
      curriculumName,
      readonlyMode,
    },
    methods: {
      handleSetSelectedClasses,
      handleCloseClassesModal,
      handleToggleEditMode,
      handleSetCurriculumName,
    },
  } = useEducationPlan();

  return (
    <>
      <AppFlex direction="column" unit="16">
        <AppFlex
          direction="row"
          unit="8"
          alignItems="center"
          justifyContent="flex-end"
          style={{ marginBottom: 8 }}
        >
          <AppButton
            type="primary"
            htmlType="button"
            onClick={() => handleToggleEditMode(!editMode)}
            disabled={readonlyMode}
          >
            <AppFlex direction="row" alignItems="center" unit="8">
              <span>{editMode ? 'Сохранить' : 'Редактировать'}</span>
              <EditOutlined style={{ fontSize: '20px' }} />
            </AppFlex>
          </AppButton>
        </AppFlex>
        {editMode ? (
          <AppInput
            value={curriculumName}
            onChange={(e) => handleSetCurriculumName(e.target.value)}
            placeholder="Название учебного плана"
            className={styles.curriculumName_input}
          />
        ) : (
          <AppText size={18}>{curriculumName}</AppText>
        )}
      </AppFlex>

      <AppTable
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        rowKey={(record) => record.key}
        scroll={{ x: 'max-content' }}
        bordered
        size="small"
      />

      <AddClassesModal
        visible={classesModalVisible}
        onCancel={handleCloseClassesModal}
        educationClasses={educationClasses}
        selectedClassKeys={selectedClassKeys}
        onChange={handleSetSelectedClasses}
      />
    </>
  );
};
